export function parseForMarkdownLinks(text, color="#ffd569", target="_blank") {
  const regex = /\[(.*?)\]\((.*?)\)/g;
  return text.replace(regex, `<a style="color:${color}" class="link" href="$2" target="${target}" rel="noopener noreferrer">$1</a>`);
}

export function parseForMarkdownBold(text) {
  const regex = /\*\*(.*?)\*\*/g;
  return text.replace(regex, "<strong>$1</strong>");
}

export function convertNumberToPrice(number) {
  const price = `Kr. ${new Intl.NumberFormat("da-DK", { minimumFractionDigits: 2 }).format(number)}`;
  return price.replace(",00", ",-");
}
